import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const CoverContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  & .titleContent {
    width: 100%;
    color: ${v.ezBackColor};
    font-size: 30px;
    font-weight: bold;
    border-bottom: 1.5px dashed #CCCCCC;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }

  & .titleContent .accessoriesContent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }

  & .pageContainer {
    background: #FFF;
    display: flex;
    width: fit-content;
    height: fit-content;
    flex-direction: column;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.16);
    margin: 20px 0px;
  }

  @media print {

    zoom: 85% !important;

    & .pageContainer { 
      box-shadow: unset;
    }

    & .headerContainer, & .titleContent {
      display: none;
    }
  }

  & .documentDataContainer { 
    width: 21cm;
    height: 29.7cm;
    margin: 16mm 16mm 16mm 16mm;
    background: #FFF;
  }

  & .documentDataContainer .bp3-progress-bar .bp3-progress-meter {
    background-color: ${v.ezMainColor};
  }

  .t22, .t22b { font-size: 22px; }
  .t20, .t20b { font-size: 20px; }
  .t18, .t18b { font-size: 18px; }
  .t16, .t16b { font-size: 16px; }

  .t22b, .t20b, .t18b, .t16b { font-weight: bold; }

  & .documentDataContainer .headerContent, 
  & .documentDataContainer .dataContent {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  & .documentDataContainer .headerContent .left,
  & .documentDataContainer .headerContent .center,
  & .documentDataContainer .headerContent .right {
    display: flex;
    flex: 1;
  }

  & .documentDataContainer .headerContent .right {
    justify-content: space-between;
    flex-direction: column;
  }

  & .documentDataContainer .headerContent .right div {
    display: flex;
    justify-content: flex-end;
  }

  & .documentDataContainer .headerContent .center div.specialCreditTerm {
    display: flex;
    justify-content: center;
    font-size: 1.5rem;
    color: ${v.ezRedColor};
    width: 100%;
    align-items: center;
    font-weight: bold;
  }

  & .documentDataContainer .separator {
    width: 100%;
    margin: 10px 0px;
    border-bottom: solid 0.5px ${v.borderGray};
  }

  & .documentDataContainer .dataContent {
    
  }

  & .documentDataContainer .dataContent .left {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  & .documentDataContainer .dataContent .left .row div:last-child   {
    word-break: break-word;
    max-width:33rem;
  }

  & .documentDataContainer .dataContent .left .row {
    display: flex;
    flex: 1;
    flex-direction: row;
    height: 27px;
  }

  & .documentDataContainer .dataContent .right {
    display: flex;
    width: 200px;
  }

  & .documentDataContainer .dataContent .right img {
    height: 200px;
    width: 200px;
  }
`

export const ContactPointContainer = styled.div`
  display: flex;
  width: 100%;
  border-radius: 5px;
  background: #FFF;
  padding: 12px 0px;
  margin-top: 20px;
  font-family: 'IBM Plex Sans Thai';
  flex-direction: column;

  .contactPointHeader {
    font-size: 20px;
    font-weight: bold;
  }

  .contactContent {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-top: 5px;
  }

  .contactGroupTitle {
    display: flex;
    width: 100%;
    flex-direction: row;
    font-weight: bold;
  }

  .contactValueContent {
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .contactValue {
    width: 40%;
    min-width: 180px;
    font-size: 16px;
    height: 25px;
    display: flex;
    align-items: center;

    svg {
      margin-right: 8px;
    }

    svg path {
      color: ${v.textBlack};
    }
  }
`

export const AttachContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 25px;
  flex-direction: column;
  margin-bottom: 10px;

  .ReactTable .rt-thead .rt-th, .ReactTable .rt-thead .rt-td {
    white-space: unset;
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: bold;
    background: #FFF;
  }

  & .title {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  & .content {
    display: flex;
    flex-direction: row;
  }

  & .content .left, 
  & .content .right {
    display: flex;
    width: 50%;
    flex-direction: column;
  }

  & .content .right {
    border-left: solid 0.5px ${v.borderGray};
    padding-left: 10px;
  }

  & .content .left .sectionTitle, 
  & .content .right .sectionTitle {
    font-size: 18px;
    font-weight: bold;
    text-decoration: underline;
  }

  & .content .left .checkbox, 
  & .content .right .checkbox {
    font-size: 16px;
    margin-top: 10px;
  }

  .ui.checkbox input[disabled]~label {
    opacity: 1;
  }
`